'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotCandlestickAltIcon = function PlotCandlestickAltIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M8.688 0h1.313v32H8.688zm6.625 0h1.375v32h-1.375zm0 5.313h1.375c.75 0 1.313.563 1.313 1.375v6.625c0 .813-.563 1.375-1.313 1.375h-1.375c-.75 0-1.313-.563-1.313-1.375V6.688c0-.813.563-1.375 1.313-1.375zM8.688 20h1.313c.813 0 1.313.563 1.313 1.313v6.688c0 .813-.5 1.313-1.313 1.313H8.688c-.813 0-1.375-.5-1.375-1.313v-6.688c0-.75.563-1.313 1.375-1.313zM2 0h1.313v32H2zm0 10.688h1.313c.813 0 1.375.5 1.375 1.313v6.688c0 .75-.563 1.313-1.375 1.313H2c-.813 0-1.313-.563-1.313-1.313v-6.688c0-.813.5-1.313 1.313-1.313zM22 0h1.313v32H22zm0 14.688h1.313c.813 0 1.375.5 1.375 1.313v6.688c0 .75-.563 1.313-1.375 1.313H22c-.813 0-1.313-.563-1.313-1.313v-6.688c0-.813.5-1.313 1.313-1.313zM28.688 0h1.313v32h-1.313zm0 2.688h1.313c.813 0 1.313.5 1.313 1.313v6.688c0 .75-.5 1.313-1.313 1.313h-1.313c-.813 0-1.375-.563-1.375-1.313V4.001c0-.813.563-1.313 1.375-1.313z' })
    );
};

exports.default = PlotCandlestickAltIcon;